export default __webpack_public_path__ + "static/media/goshen66.57ba2258.jpg";